import React, { useState, useEffect } from 'react';
import api from '../../api/axiosConfig';

function formatRelTime(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const now = new Date();
    const diffMs = now - date;
    const diffMin = Math.floor(diffMs / 60000);
    const diffHrs = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMin < 1) return 'Ahora';
    if (diffMin < 60) return `Hace ${diffMin} min`;
    if (diffHrs < 24) return `Hace ${diffHrs} hs`;
    if (diffDays === 1) return 'Ayer';
    if (diffDays < 7) return `Hace ${diffDays} dias`;
    return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit' });
}

export default function PanelPrincipalAdministrador({ user, onNavigate }) {
    const [procCount, setProcCount] = useState(null);
    const [userCount, setUserCount] = useState(null);
    const [entCount, setEntCount] = useState(null);
    const [entidades, setEntidades] = useState([]);
    const [loadingEnt, setLoadingEnt] = useState(true);
    const [actividad, setActividad] = useState([]);
    const [loadingAct, setLoadingAct] = useState(true);
    const [resumenSemanal, setResumenSemanal] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        api.post('/contarTramitesActivos')
            .then(res => setProcCount(res.data?.total ?? null))
            .catch(() => setProcCount(null));
        api.get('/obtenerTodasLasEntidades')
            .then(res => {
                const data = res.data?.data || res.data || [];
                setEntCount(Array.isArray(data) ? data.length : 0);
            })
            .catch(() => setEntCount(0));
        api.post('/obtenerUsuarios')
            .then(res => {
                const data = res.data || [];
                const clientes = Array.isArray(data) ? data.filter(u => {
                    const r = (u.rol || '').toLowerCase();
                    return r !== 'admin' && r !== 'administrador';
                }) : [];
                setUserCount(clientes.length);
            })
            .catch(() => setUserCount(0));
        api.post('/obtenerResumenSemanal')
            .then(res => setResumenSemanal(res.data))
            .catch(() => setResumenSemanal(null));
    }, []);

    useEffect(() => {
        setLoadingEnt(true);
        setLoadingAct(true);
        api.post('/obtenerEntidadesConTramites')
            .then(res => setEntidades(res.data || []))
            .catch(() => setEntidades([]))
            .finally(() => setLoadingEnt(false));
        api.post('/obtenerActividadReciente')
            .then(res => setActividad(res.data || []))
            .catch(() => setActividad([]))
            .finally(() => setLoadingAct(false));
    }, []);

    if (!user) return null;

    return (
        <div className="dashboard-content">
            <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <h1 className="page-title">Panel de Administracion - Bienvenido, {user.nombre}</h1>
                    <p className="page-subtitle">Vista general de todos los movimientos del Estudio Metzger</p>
                </div>
            </div>

            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-icon blue"><i className="bi bi-clipboard-check"></i></div>
                    <div className="stat-details">
                        <h3>{procCount !== null ? procCount : '...'}</h3>
                        <p>Trámites Activos</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon green"><i className="bi bi-people"></i></div>
                    <div className="stat-details">
                        <h3>{userCount !== null ? userCount : '...'}</h3>
                        <p>Clientes Registrados</p>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon orange"><i className="bi bi-building"></i></div>
                    <div className="stat-details">
                        <h3>{entCount !== null ? entCount : '...'}</h3>
                        <p>Entidades Totales</p>
                    </div>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr', gap: '24px', marginTop: '24px', alignItems: 'stretch' }}>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {resumenSemanal && (
                    <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', padding: '20px 24px' }}>
                        <h3 style={{ margin: '0 0 16px 0', color: '#1e293b', borderBottom: '1px solid #f1f5f9', paddingBottom: '12px', fontSize: '15px' }}>
                            <i className="bi bi-bar-chart" style={{ marginRight: 8, color: '#2a5a8a' }}></i>Resumen de Trámites
                        </h3>
                        <div style={{ display: 'flex', gap: '12px', flexDirection: 'column' }}>
                        <div style={{ flex: 1, background: '#f8fafc', padding: '14px 18px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#ebf4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#2a5a8a' }}>
                                <i className="bi bi-play-circle"></i>
                            </div>
                            <div>
                                <div style={{ fontSize: '20px', fontWeight: 700, color: '#1a3c5e' }}>{resumenSemanal.iniciados_semana}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>Iniciados esta semana</div>
                            </div>
                        </div>
                        <div style={{ flex: 1, background: '#f8fafc', padding: '14px 18px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#059669' }}>
                                <i className="bi bi-check2-circle"></i>
                            </div>
                            <div>
                                <div style={{ fontSize: '20px', fontWeight: 700, color: '#065f46' }}>{resumenSemanal.completados_total}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>Completados totales</div>
                            </div>
                        </div>
                        <div style={{ flex: 1, background: '#f8fafc', padding: '14px 18px', borderRadius: '10px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ width: '40px', height: '40px', borderRadius: '10px', background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', color: '#dc2626' }}>
                                <i className="bi bi-arrow-right-circle"></i>
                            </div>
                            <div>
                                <div style={{ fontSize: '20px', fontWeight: 700, color: '#991b1b' }}>{resumenSemanal.activos_actuales}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>En curso ahora</div>
                            </div>
                        </div>
                        </div>
                    </div>
                    )}
                    <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '1px solid #f1f5f9', paddingBottom: '12px' }}>
                            <h3 style={{ margin: 0, color: '#1e293b' }}><i className="bi bi-clipboard-check" style={{ marginRight: 8, color: '#1a3c5e' }}></i>Entidades con Trámites Activos</h3>
                            {onNavigate && (
                                <button onClick={() => onNavigate(null)} style={{ background: 'none', border: 'none', color: '#2a5a8a', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
                                    Ver todos <i className="bi bi-arrow-right"></i>
                                </button>
                            )}
                        </div>

                        {loadingEnt ? (
                            <p style={{ color: '#64748b', textAlign: 'center', padding: '40px 0' }}>Cargando...</p>
                        ) : entidades.length === 0 ? (
                            <p style={{ color: '#64748b', textAlign: 'center', padding: '40px 0' }}>No hay entidades con trámites activos.</p>
                        ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                {entidades.slice(0, 3).map((ent, index) => (
                                    <div
                                        key={ent.id}
                                        onClick={() => onNavigate && onNavigate(ent.id)}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '12px',
                                            padding: '12px 14px', borderRadius: '8px',
                                            border: '1px solid #e2e8f0', cursor: onNavigate ? 'pointer' : 'default',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#bfdbfe'; e.currentTarget.style.background = '#f8fafc'; }}
                                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.background = 'transparent'; }}
                                    >
                                        <span style={{ fontSize: '13px', fontWeight: 700, color: '#94a3b8', minWidth: '28px' }}>#{index + 1}</span>
                                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                            <span style={{ fontSize: '14px', fontWeight: 600, color: '#1a3c5e' }}>{ent.nombre}</span>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>{ent.cuit || ''}</span>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px', textAlign: 'right' }}>
                                            <span style={{ fontSize: '20px', fontWeight: 700, color: '#2a5a8a' }}>{ent.total_tramites}</span>
                                            <span style={{ fontSize: '12px', color: '#64748b' }}>trámite{ent.total_tramites !== 1 ? 's' : ''}</span>
                                        </div>
                                        <i className="bi bi-chevron-right" style={{ fontSize: '16px', color: '#94a3b8' }}></i>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
                    <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <h3 style={{ margin: '0 0 16px 0', color: '#1e293b', borderBottom: '1px solid #f1f5f9', paddingBottom: '12px' }}><i className="bi bi-activity" style={{ marginRight: 8, color: '#2a5a8a' }}></i>Actividad Reciente</h3>
                        
                        {loadingAct ? (
                            <p style={{ color: '#64748b', textAlign: 'center', padding: '20px 0' }}>Cargando...</p>
                        ) : actividad.length === 0 ? (
                            <p style={{ color: '#64748b', textAlign: 'center', padding: '20px 0' }}>Sin actividad aún.</p>
                        ) : (
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '13px' }}>
                                {actividad.slice(0, isMobile ? 5 : undefined).map((item, idx) => {
                                    const info = {
                                        tramite_iniciado: { color: '#2a5a8a', icon: 'bi-play-circle' },
                                        paso_completado: { color: '#059669', icon: 'bi-check-circle' },
                                        tramite_completado: { color: '#7c3aed', icon: 'bi-trophy' },
                                        plantilla_creada: { color: '#d97706', icon: 'bi-file-earmark-plus' },
                                    }[item.tipo] || { color: '#64748b', icon: 'bi-record' };
                                    return (
                                        <li key={item.tipo + '-' + idx} style={{ display: 'flex', gap: '12px', marginBottom: '14px' }}>
                                            <div style={{
                                                width: '30px', height: '30px', borderRadius: '50%',
                                                backgroundColor: info.color + '18',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                flexShrink: 0, fontSize: '13px', color: info.color
                                            }}>
                                                <i className={`bi ${info.icon}`}></i>
                                            </div>
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <div style={{ color: '#334155', fontSize: '13px', fontWeight: 500, lineHeight: 1.3 }}>
                                                    {item.descripcion}
                                                </div>
                                                {item.entidad_nombre && (
                                                    <div style={{ color: '#64748b', fontSize: '12px', marginTop: '1px' }}>
                                                        {item.entidad_nombre}
                                                    </div>
                                                )}
                                                <div style={{ color: '#94a3b8', fontSize: '11px', marginTop: '2px' }}>
                                                    {formatRelTime(item.fecha)}
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
